import React from "react";
import {useTranslation} from "react-i18next";
import styles from './shippings.module.css';
import {Button} from "../index";

interface Props {
  trackingList: string[];
  onReset?: () => void;
}

export function SelectedShippings({onReset, trackingList}: Props) {
  const {t} = useTranslation("shipping");
  
  return (<div className={styles.container}>
    <div className={styles.list}>
      {trackingList && trackingList.map((tracking, idx) => (<div key={"check" + idx} className={styles.shipping}>
        {tracking}
      </div>))}
    </div>
    <Button
      variant={"text"}
      className={styles.reset}
      onClick={onReset}
    >
      <span>{t("reset")}</span>
      <span>{trackingList?.length || 0}</span>
    </Button>
  </div>);
};
